import type { ReactElement } from "react"
import React from "react"
import _t from "@core/i18n"
import type { ProductFeatureSlider } from "@onestore-graphql/Model"
import ToggleSectionContainerOrg from "@onestore/hel/dist/components/organisms/ToggleSectionContainerOrg"
import Picture from "@onestore/hel/dist/components/quarks/Picture"
import SliderTemplate from "@onestore/hel/dist/components/templates/SliderTemplate"
import assetsSquidexToImageObject from "~/lib/assetsSquidexToImageObject"

interface MarketFeatureSliderProps {
  featureSlider: ProductFeatureSlider[]
}

export default function MarketFeatureSlider({
  featureSlider,
}: MarketFeatureSliderProps): ReactElement<MarketFeatureSliderProps> | null {
  if (featureSlider.length === 0) {
    return null
  }

  const slides = featureSlider.map(
    ({ flatData: { image, title, description } }) => ({
      image: (
        <Picture srcData={assetsSquidexToImageObject(image, title || "")} />
      ),
      title: title,
      text: description,
    })
  )

  return (
    <ToggleSectionContainerOrg
      color="darkLight"
      heading={_t("marketplace.gallery")}
      spacing="small"
      hideHeadingOnBiggerScreen
      hasOverflowHidden
    >
      <SliderTemplate slides={slides} />
    </ToggleSectionContainerOrg>
  )
}
